(function () {
    'use strict';

    var course_tile_info_exists = !!document.querySelector('.course-tile');

    if (course_tile_info_exists) {

        var all_course_tile_infos = document.querySelectorAll('.course-tile');

        for (let i = 0; i < all_course_tile_infos.length; i++) {

            const this_course = all_course_tile_infos[i];

            this_course.querySelector('button.course-tile__assessment__title').addEventListener('click', function () {

                this_course.querySelector('.course-tile__assessment__dropdown')["classList"].toggle('course-tile__assessment__dropdown--open');

                this["classList"].toggle('course-tile__assessment__title--open');

            });

            let assessments = this_course.querySelectorAll('.course-tile__assessment__item');

            for (let j = 0; j < assessments.length; j++) {
                const this_assessment = assessments[j];

                this_assessment.querySelector('button.course-tile__assessment__item__toggler').addEventListener('click', function () {

                    this_assessment["classList"].toggle('course-tile__assessment__item--open');

                });

            }

            // Resize function for positioning modal correctly.
            // Pseudo done resizing event

            var course_coordinator_sections = document.querySelectorAll('.course-tile__coordinator');

            moveModalInsideDom(course_coordinator_sections);

            var myEfficientFn = debounce(function () {

                // Resizing has "stopped"
                moveModalInsideDom(course_coordinator_sections);


            }, 250);

            window.addEventListener('resize', myEfficientFn);

        }

    }

}());

function debounce(func, wait, immediate) {
    var timeout;
    return function () {
        var context = this,
            args = arguments;
        var later = function () {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
};

function moveModalInsideDom(course_coordinator_sections) {
    if (course_coordinator_sections) {

        for (let i = 0; i < course_coordinator_sections.length; i++) {
            const course_coordinator_section = course_coordinator_sections[i];

            let modal_dialogue = course_coordinator_section.querySelector('.coordinator-modal__dialogue');
            let modal_info_icon = course_coordinator_section.querySelector('.coordinator-modal__icon');

            if (modal_dialogue && modal_info_icon) {

                let is_desktop = window.matchMedia("(min-width: 992px)")["matches"];

                // If desktop
                if (is_desktop) {
                    modal_info_icon.prepend(modal_dialogue);
                } else {
                    course_coordinator_section.append(modal_dialogue);
                }

            }

        }

    }
};